import styles from "./Navbar.module.css"
import catermatLogo from '../../../assets/images/catermatLogo.svg';
import { useState } from 'react';
import { Menu } from 'lucide-react';
import UserButton from "../../Button/UserButton/UserButton";
import { useUserContext } from "../../../context/UserContext";
import { useWindowSize } from "../../../hooks/useWindowSize";
import MenuBlock from "../Menu/Menu";
/**
* Navbar - onboarding version.
* Contains various links, language and currency swittch and a logout option
*
* @returns TSX.Element
*/
const Navbar = () => {
    const { loggedIn, logout } = useUserContext(); // User data
    const screenWidth = useWindowSize(); // Screen width
    const [menuOpen, setMenuOpen] = useState<boolean>(false); // Toggle mobile menu
    
    return(
        <>
        <MenuBlock display={menuOpen} handleDisplay={setMenuOpen} version="onboarding"/>
            <div className={styles.Navbar}>
                {screenWidth > 700 ? (
                    <>
                    <img className={styles.Logo} src={catermatLogo} alt="Catermat Logo"></img>
                    <div className={styles.NavbarMenu}>
                        <UserButton
                            LoggedIn={loggedIn}
                            logout={logout}
                        />
                    </div>
                    </>
                ) : (
                    <>
                    <img className={styles.Logo} src={catermatLogo} alt="Catermat Logo"></img>
                    <div className={styles.NavbarMenu}>
                        <button className={styles.BurgerMenu} onClick={()=>setMenuOpen(true)}>
                            <Menu/>
                        </button>
                    </div>
                    </>
                )}
            </div>
        </>
    )
};

export default Navbar;